import DealLinkSuccessStep from 'layouts/DealLinkSuccessStep'
import OnboardingIntentStep from 'layouts/OnboardingIntentStep'
import OnboardingInstallStep from 'layouts/OnboardingInstallStep'
import OnboardingCompanyInfo from 'containers/OnboardingCompanyInfo'
import OnboardingSuccessStep from 'layouts/OnboardingSuccessStep'

export default Object.freeze([
  {
    route: '/welcome',
    component: DealLinkSuccessStep,
  },
  {
    route: '/company',
    component: OnboardingCompanyInfo,
  },
  {
    route: '/intent',
    component: OnboardingIntentStep,
  },
  {
    route: '/install',
    component: OnboardingInstallStep,
  },
  {
    route: '/woohoo',
    component: OnboardingSuccessStep,
  }
])



// WEBPACK FOOTER //
// ./src/flows/DealOnboardingFlow/routes.js